export default "__VITE_ASSET__DWjmMhOp__"